import { useMutation } from '@tanstack/react-query'

import { CreateCheckoutSessionRequest } from '@pkg/types/api'

import api from '@/api'

export const useCreateCheckoutSession = () => {
  return useMutation({
    mutationFn: async (data: CreateCheckoutSessionRequest) => {
      return (await api.createCheckoutSession(data)).data
    },
  })
}
